import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationUnknown } from './interfaces';

interface Props {
  operation: OperationUnknown;
}

const UnknownOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, customerMsisdn } = operation;

  const error =
    details.errorCode && details.errorMessage
      ? { errorCode: details.errorCode, errorMessage: details.errorMessage }
      : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.customerMsisdn,
              value: detailsValueFormatter(customerMsisdn)
            },
            { label: locales.operation.label.customerEmail, value: details.customerEmail },
            { label: locales.operation.label.productId, value: details.productId },
            {
              label: locales.operation.label.acquirerMsisdn,
              value: detailsValueFormatter(details.acquirerMsisdn)
            }
          ]}
        />
      }
    />
  );
};

export default UnknownOperation;
